import { usePageLoadStatus } from 'src/hooks/usePageLoadStatus';

/**
 * Component responsible for rendering the hidden element that indicates successful page load
 * for synthetic monitoring purposes. This component should be included once at the app level
 * to ensure the hidden element appears on all routes when the page is fully loaded.
 */
export function PageLoadMonitor() {
  const { isPageFullyLoaded, loadedComponents } = usePageLoadStatus();

  if (!isPageFullyLoaded) {
    return null;
  }

  return (
    <div
      id="page-load-success-indicator"
      data-testid="page-load-success-indicator"
      data-page-loaded="true"
      data-components={loadedComponents.join(',')}
      data-timestamp={new Date().toISOString()}
      style={{
        display: 'none',
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '-1',
        opacity: '0',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
      aria-hidden="true"
    >
      Page loaded successfully at {new Date().toISOString()}
      Components: {loadedComponents.join(',')}
    </div>
  );
}
